<template>
  <div :style="setExpandedViewStyle()" class="expanded-view-container">
    <div class="expanded-view-group-1">
      <label>{{ currentDate }}</label>
      <img @click="$emit('close')" src="@/assets/CloseIconGreen.svg" />
    </div>
    <div class="expanded-view-group-2">
      <div
        @click="$emit('edit', { task: task, event: $event })"
        v-for="task in tasks"
        :key="task.id"
        class="expanded-view-assignment"
      >
        <label>{{ task.title }}</label>
        <div class="expanded-view-three-dots">...</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    coords: Object,
    tasks: Array,
    choreDetails: Object
  },
  data() {
    return {
      currentDate: ''
    }
  },
  methods: {
    setExpandedViewStyle() {
      return {
        top: `${this.coords.y}px`,
        left: `${this.coords.x}px`
      }
    }
  },
  mounted() {
    this.currentDate = moment
      .utc(this.tasks[0].startDate)
      .format('DD MMM YYYY')
      .toString()
  }
}
</script>
<style scoped>
.expanded-view-container {
  position: fixed;
  z-index: 1;
  min-width: 168px;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  display: flex;
  padding: 8px;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: stretch;
  width: 256px;
}
.expanded-view-container img {
  cursor: pointer;
}

.expanded-view-group-1 {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  border-bottom: 1px solid #e5e9ed;
  padding: 8px;
}

.expanded-view-assignment {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 4px;
  height: 28px;
  border: 0.5px solid #66b015;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 8px 0 8px 0;
  cursor: pointer;
}

.expanded-view-assignment label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 20px;
  color: #66b015;
}

.expanded-view-three-dots {
  transform: rotate(90deg);
  font-size: 20px;
  display: inline-block;
  right: 0;
  color: #66b015;
}
</style>
